export const STORAGE_KEY = 'rovo_chat_auto_convo_fired';
